const __prod__ = process.env.NODE_ENV === 'production';
const __dev__ = process.env.NODE_ENV === 'development';

export { __prod__, __dev__ };
